import { useMemo } from "react";
import { WIDGET_HOST } from "@/shared/config/env";
import { buildLinkParts, partsToUrl, type LinkParts } from "@/shared/lib/referralLink";
import { useReferral } from "./referralContext";

interface ReferralLink {
  parts: LinkParts;
  url: string;
  /** Без партнёрского ID и без выбранных СК ссылка бессмысленна — блок выдачи и предпросмотр скрыты. */
  isReady: boolean;
}

export function useReferralLink(): ReferralLink {
  const {
    partnerId,
    chan,
    b,
    entryPoint,
    companies,
    companiesCleared,
    hideHeader,
    hideFooter,
    noJivochat,
    utm,
  } = useReferral();

  return useMemo(() => {
    const parts = buildLinkParts(
      { partnerId, chan, b, entryPoint, companies, hideHeader, hideFooter, noJivochat, utm },
      WIDGET_HOST,
    );

    return {
      parts,
      url: partsToUrl(parts),
      isReady: Boolean(partnerId.trim()) && !companiesCleared,
    };
  }, [
    partnerId,
    chan,
    b,
    entryPoint,
    companies,
    companiesCleared,
    hideHeader,
    hideFooter,
    noJivochat,
    utm,
  ]);
}
